/**
 * Runtime configuration for the Hey API fetch client.
 *
 * Each frontend imports `configureApiClient()` at startup (in main.tsx,
 * before rendering) to set the base URL and credentials mode for the
 * generated SDK's singleton client.
 *
 * In dev, each frontend hits the local API at http://127.0.0.1:8000.
 * The host MUST match what the Vite dev server binds to (127.0.0.1) so
 * the page origin and the API origin are the same site — otherwise
 * `SameSite=Strict` cookies set by /api/v1/client-auth/login etc. won't
 * be sent on subsequent fetches to the API. (Browsers treat
 * `localhost` and `127.0.0.1` as different hosts even though they
 * resolve to the same IP.)
 *
 * In prod, the frontends are served by Caddy on operative.signumcyber.com /
 * hackereyes.signumcyber.com and the API is proxied at /api on the same
 * origin, so VITE_API_BASE_URL becomes "/api".
 *
 * Vite exposes env vars prefixed with VITE_ via `import.meta.env`.
 */
import { client } from "./generated/client.gen";

export function getApiBaseUrl(): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const env = (import.meta as any).env as Record<string, string | undefined>;
  return env?.VITE_API_BASE_URL ?? "http://127.0.0.1:8000";
}

export function configureApiClient(): void {
  client.setConfig({
    baseUrl: getApiBaseUrl(),
    credentials: "include",
  });
}
